import {
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormGroup,
  Grid,
  Modal,
  Switch,
  makeStyles,
  withStyles
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  createUserGroup,
  fetchUserGroups,
  fetchUsersAndUserGroups,
  handleCreatingGroupAction,
  handleInCreatingAndSharingFlagAction,
  handleIsSharingFlag,
  userGroupSearchUsers,
  userGroupShareFlag
} from '../../redux/actions/app-actions';
import { firebase } from '../../firebase';
import { classifyFlagsForDeletionAndSharing } from '../../utils/flag';
import '../styles/share-flags.css';
import ShareFlagsCreateGroupInput from './ShareFlagsCreateGroupInput';
import ShareFlagsCreateGroupSelectedUserList from './ShareFlagsCreateGroupSelectedUserList';
import ShareFlagsListItem from './ShareFlagsListItem';
import ShareFlagsModalFooter from './ShareFlagsModalFooter';
import ShareFlagsModalHeader from './ShareFlagsModalHeader';
import ShareFlagsSearchInput from './ShareFlagsSearchInput';
import UnsharableFlagsWarning from './UnsharableFlagsWarning';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex'
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#E31690',
        borderColor: '#E31690'
      }
    }
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none'
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white
  },
  checked: {}
}))(Switch);

const ShareFlags = ({
  open,
  onClose,
  flagsToShare,
  userGroups,
  shareFlag,
  isSharingFlag,
  isCreatingGroup,
  handleSharing,
  handleCreatingAndSharing,
  handleCreatingGroup,
  searchUsers,
  userGroupsSearchUsers,
  createGroup,
  fetchGroups,
  searchUsersAndUserGroups,
  usersAndUserGroups
}) => {
  const classes = useStyles();
  const [allUsers, setAllUsers] = useState([]);
  const [allUserGroups, setAllUserGroups] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedGroupUsers, setSelectedGroupUsers] = useState([]);
  const [hasComments, setHasComments] = React.useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [initialUserLoad, setInitialUserLoad] = useState(false);
  const [inputGroupName, setInputGroupName] = useState('');
  const [createGroupError, setCreateGroupError] = useState({
    hasError: false,
    errorMessage: ''
  });
  const [flagsToBeShared, setFlagsToBeShared] = useState([]);
  const [specialFlags, setSpecialFlags] = useState([]);

  const handleClose = async () => {
    onClose();
    setActiveStep(0);
    setSelectedGroups([]);
    setSelectedUsers([]);
    setSelectedItems([]);
    setSelectedGroupUsers([]);
    setInputGroupName('');
    setSearchQuery('');
    setHasComments(true);
    setInitialUserLoad(false);
    setAllUsers([]);
    setAllUserGroups([]);
    if (createGroupError.hasError) {
      setCreateGroupError({ hasError: false, errorMessage: '' });
    }
  };

  const handleGroupSelection = (object) => {
    const { event, itemChipID, type } = object;
    const { value, checked } = event.target;
    if (checked) {
      setSelectedGroups([...selectedGroups, value]);
      setSelectedItems([...selectedItems, { value, itemChipID, type }]);
    } else {
      setSelectedGroups(selectedGroups.filter((group) => group !== value));
      setSelectedItems(
        selectedItems.filter((item) => item.itemChipID !== itemChipID)
      );
    }
  };

  const handleUserSelection = (object) => {
    const { event, itemChipID, type } = object;
    const { value, checked } = event.target;
    if (checked) {
      setSelectedUsers([...selectedUsers, value]);
      setSelectedItems([...selectedItems, { value, itemChipID, type }]);
    } else {
      setSelectedUsers(selectedUsers.filter((user) => user !== value));
      setSelectedItems(
        selectedItems.filter((item) => item.itemChipID !== itemChipID)
      );
    }
  };

  const handleCreateUserSelection = (object) => {
    const { event, itemChipID, type } = object;
    const { value, checked } = event.target;
    if (checked) {
      setSelectedGroupUsers([
        ...selectedGroupUsers,
        { value, itemChipID, type }
      ]);
    } else {
      setSelectedGroupUsers(
        selectedGroupUsers.filter((item) => item.itemChipID !== itemChipID)
      );
    }
  };

  const handleChange = (event) => {
    setHasComments(event.target.checked);
  };

  const onHandleChipItemDelete = (item) => {
    setSelectedItems(
      selectedItems.filter(
        (selectedItem) => selectedItem.itemChipID !== item.itemChipID
      )
    );
    if (item.type === 'group') {
      setSelectedGroups(selectedGroups.filter((group) => group !== item.value));
    } else {
      setSelectedUsers(selectedUsers.filter((user) => user !== item.value));
    }
  };

  const chipItemLabelName = (item) => {
    if (item.type === 'group') {
      const labelName = allUserGroups?.filter(
        (group) => group.id === parseInt(item.value, 10)
      );
      if (labelName.length > 0) {
        const { name } = labelName[0];
        return name;
      }
    } else {
      const labelName = allUsers?.filter(
        (user) => user.userId === parseInt(item.value, 10)
      );
      if (labelName.length > 0) {
        const { name } = labelName[0];
        return name;
      }
    }
  };

  const onHandleChipCreateGroupItemDelete = (item) => {
    setSelectedGroupUsers(
      selectedGroupUsers.filter(
        (selectedItem) => selectedItem.itemChipID !== item.itemChipID
      )
    );
  };

  const handleSelectedGroupId = () =>
    selectedGroups.map((group) => Number.parseInt(group, 10));

  const handleSelectedUsersId = () =>
    selectedUsers?.map((user) => Number.parseInt(user, 10)) ?? [];

  const handleInputChange = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
    if (value.trim() !== '' && activeStep === 0) {
      setActiveStep(1);
      return;
    }
  };

  const handleGroupInputChange = (event) => {
    const { value } = event.target;
    setInputGroupName(value);
    if (createGroupError) {
      setCreateGroupError({ hasError: false, errorMessage: '' });
    }
  };

  const handleShareFlagAction = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    handleSharing(true);
    if (token) {
      try {
        const sharePromises = flagsToBeShared.map((item) => {
          return shareFlag(
            token,
            item.flagId,
            hasComments,
            handleSelectedGroupId(),
            handleSelectedUsersId()
          );
        });
        await Promise.all(sharePromises);
        await handleClose();
        handleSharing(false);
      } catch (error) {
        handleSharing(false);
        await handleClose();
      }
    }
  };

  const mapGroupUsers = () =>
    selectedGroupUsers.map((user) => ({ userId: user.value }));

  const handleCreateGroup = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    handleCreatingGroup(true);
    if (token) {
      try {
        const res = await createGroup(
          token,
          inputGroupName,
          flagsToBeShared[0]?.feedUrl,
          mapGroupUsers()
        );
        if (res.payload?.status !== 200) {
          throw new Error(res.payload?.response?.data);
        } else {
          await fetchGroups(token, flagsToBeShared[0]?.feedUrl);
          handleCreatingGroup(false);
          setActiveStep(0);
          setSelectedGroupUsers([]);
          setInputGroupName('');
        }
      } catch (error) {
        handleCreatingGroup(false);
        setCreateGroupError({
          hasError: true,
          errorMessage:
            error.message === 'DUPLICATE GROUP NAME'
              ? 'Group name already exists. Please enter a unique name.'
              : 'Something went wrong.'
        });
      }
    }
  };

  const handleCreateGroupAndShareFlag = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    const flagsToShare = flagsToBeShared;
    handleCreatingAndSharing(true);
    if (token) {
      try {
        const userGroup = await createGroup(
          token,
          inputGroupName,
          flagsToBeShared[0]?.feedUrl,
          mapGroupUsers()
        );
        if (userGroup.payload?.status !== 200) {
          throw new Error(userGroup.payload?.response?.data);
        } else {
          const sharePromises = flagsToBeShared.map((item) => {
            return shareFlag(
              token,
              item.flagId,
              hasComments,
              [userGroup.payload.data.id],
              []
            );
          });
          await Promise.all(sharePromises);
          handleCreatingAndSharing(false);
          await handleClose();
        }
      } catch (error) {
        handleCreatingAndSharing(false);
        if (error.message === 'DUPLICATE GROUP NAME') {
          setCreateGroupError({
            hasError: true,
            errorMessage:
              'Group name already exists. Please enter a unique name.'
          });
        } else {
          await handleClose();
        }
      }
    }
  };

  const handleShareButtonState = () => {
    if (activeStep === 11 && inputGroupName.trim().length > 0) {
      return inputGroupName === '';
    }
    return selectedItems.length === 0;
  };

  const handleResetUsersOption = () => {
    setSearchQuery('');
    // setSelectedUsers([]);
  };

  const handleResetGroupOption = () => {
    // setSelectedGroups([]);
  };

  const handleSearchUsers = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    setIsSearching(true);
    if (token) {
      try {
        await searchUsers(token, flagsToBeShared[0]?.feedUrl, searchQuery);
        setIsSearching(false);
      } catch (error) {
        setIsSearching(false);
      }
    }
  };

  const handleOnCreateGroupNavigationInit = () => {
    handleSearchUsers();
    setActiveStep(10);
  };

  const handleCreateGroupEditListBtn = () => {
    setActiveStep(10);
  };
  //OSEXIQPCA-2492-searchUsersAndGroups instead of searchUsers when searching
  const renderGroupListItem = () => {
    return (
      <div>
        {usersAndUserGroups?.userGroups?.map((group, index) => (
          <ShareFlagsListItem
            key={group.id}
            isGroup={true}
            item={group}
            selectedListItems={selectedGroups}
            handleItemListSelection={handleGroupSelection}
            itemInfo={{
              index,
              listLength: usersAndUserGroups?.userGroups?.length
            }}
          />
        ))}
      </div>
    );
  };

  //OSEXIQPCA-2492-searchUsersAndGroups instead of searchUsers when searching
  const renderUserListItem = () => {
    return (
      <div>
        {usersAndUserGroups?.users?.map((user, index) => (
          <ShareFlagsListItem
            key={user.userId}
            isGroup={false}
            item={user}
            selectedListItems={selectedUsers}
            handleItemListSelection={handleUserSelection}
            itemInfo={{
              index,
              listLength: usersAndUserGroups?.users?.length
            }}
          />
        ))}
        {usersAndUserGroups?.users?.length > 0 &&
          usersAndUserGroups?.userGroups?.length > 0 && (
            <Divider
              className="share-flags-modal__divider"
              variant="middle"
              style={{ marginBottom: '6px' }}
            />
          )}
        {usersAndUserGroups?.userGroups?.map((group, index) => (
          <ShareFlagsListItem
            key={group.id}
            isGroup={true}
            item={group}
            selectedListItems={selectedGroups}
            handleItemListSelection={handleGroupSelection}
            itemInfo={{
              index,
              listLength: usersAndUserGroups?.userGroups?.length
            }}
          />
        ))}
      </div>
    );
  };

  //OSEXIQPCA-2492-searchUsersAndGroups instead of searchUsers when searching
  const renderCreateGroupUserList = () => {
    return (
      <div>
        {usersAndUserGroups?.users?.map((user, index) => (
          <ShareFlagsListItem
            key={user.userId}
            isGroup={false}
            action="create"
            item={user}
            selectedListItems={selectedGroupUsers}
            handleItemListSelection={handleCreateUserSelection}
            itemInfo={{
              index,
              listLength: usersAndUserGroups?.users?.length
            }}
          />
        ))}
      </div>
    );
  };

  const renderListLoader = () => {
    return (
      <Grid
        container
        component={'div'}
        style={{ padding: '24px 4px' }}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12}>
          <CircularProgress style={{ color: '#EDEEEF' }} />
        </Grid>
      </Grid>
    );
  };

  const renderCreateGroupSelectedUserList = () => {
    return (
      <div>
        {selectedGroupUsers?.map((user, index) => (
          <ShareFlagsCreateGroupSelectedUserList
            key={user.itemChipID}
            userItem={user}
            allUsers={allUsers}
            itemInfo={{
              index,
              listLength: selectedGroupUsers?.length
            }}
          />
        ))}
      </div>
    );
  };

  const renderSelectedGroupUsersHeader = () => {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ margin: '8px 0 4px' }}
      >
        <Grid item>
          <span>{`${selectedGroupUsers?.length} Members`}</span>
        </Grid>
        <Grid item className="share-flags-modal__group-list-edit-btn">
          <Button onClick={handleCreateGroupEditListBtn}>
            <span>Edit</span>
          </Button>
        </Grid>
      </Grid>
    );
  };

  //OSEXIQPCA-2492-searchUsersAndGroups instead of searchUsers when searching
  const updateLocalUsersAndGroups = () => {
    if (!initialUserLoad && usersAndUserGroups !== null) {
      setInitialUserLoad(true);
      setAllUsers(usersAndUserGroups?.users);
      setAllUserGroups(usersAndUserGroups?.userGroups);
      return;
    }
    if (searchQuery.trim() === '' && usersAndUserGroups !== null) {
      setTimeout(() => {
        setAllUsers(usersAndUserGroups?.users);
        setAllUserGroups(usersAndUserGroups?.userGroups);
      }, 500);
    }
  };

  const handleSearchUsersAndUsersGroups = async (flags) => {
    const token = await firebase.auth.currentUser.getIdToken();
    setIsSearching(true);
    if (token) {
      try {
        await searchUsersAndUserGroups(flags[0]?.feedUrl, searchQuery, token);
        setIsSearching(false);
      } catch (error) {
        setIsSearching(false);
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (flagsToBeShared?.length > 0) {
        //OSEXIQPCA-2492-searchUsersAndGroups instead of searchUsers when searching
        handleSearchUsersAndUsersGroups(flagsToBeShared);
      }
    }, 500); // 500ms debounce time, adjust as needed

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    if (activeStep === 0) {
      handleResetUsersOption();
    }
    if (activeStep === 1) {
      handleResetGroupOption();
    }
  }, [activeStep]);

  useEffect(() => {
    updateLocalUsersAndGroups();
  }, [usersAndUserGroups]);

  useEffect(() => {
    const {
      flagsToBeShared,
      restrictedFlags
    } = classifyFlagsForDeletionAndSharing(flagsToShare);

    setFlagsToBeShared(flagsToBeShared);
    setSpecialFlags(restrictedFlags);

    if (flagsToBeShared?.length > 0) {
      //OSEXIQPCA-2492-searchUsersAndGroups instead of searchUsers when searching
      handleSearchUsersAndUsersGroups(flagsToBeShared);
    }
  }, [flagsToShare]);

  return (
    <Modal
      className={classes.modal}
      open={open}
      // onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEscapeKeyDown
    >
      <div
        className="share-flags-modal"
        style={{
          padding: activeStep === 10 ? '8px 16px 44px' : '8px 16px 16px'
        }}
      >
        <ShareFlagsModalHeader
          onClose={handleClose}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          selectedGroupUsers={selectedGroupUsers}
          onCreateGroup={handleCreateGroup}
          isCreatingGroup={isCreatingGroup}
          inputGroupName={inputGroupName}
        />
        {activeStep !== 10 && activeStep !== 11 && (
          <FormGroup>
            <Grid
              className="share-flags-modal__comment-switch-container"
              component="div"
              container
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item>
                <label className="comment-switch-label">
                  Share with comments
                </label>
              </Grid>
              <Grid item>
                <AntSwitch
                  className="share-flags-modal__comment-switch"
                  checked={hasComments}
                  onChange={handleChange}
                  name="hasCommentsSwitch"
                />
              </Grid>
              <Grid item>
                <span className="comment-switch-tag">
                  {hasComments ? 'On' : 'Off'}
                </span>
              </Grid>
            </Grid>
          </FormGroup>
        )}
        {activeStep !== 11 && (
          <ShareFlagsSearchInput
            searchQuery={searchQuery}
            handleInputChange={handleInputChange}
          />
        )}
        {activeStep === 11 && (
          <ShareFlagsCreateGroupInput
            inputGroupName={inputGroupName}
            handleGroupInputChange={handleGroupInputChange}
            groupError={createGroupError}
          />
        )}
        {activeStep === 0 && (
          <Grid
            component="div"
            className="share-flags-modal__create-group"
            container
          >
            <Grid item xs={12}>
              <Button
                className="share-flags-modal__create-nav-btn"
                onClick={handleOnCreateGroupNavigationInit}
              >
                <div className="share-flags-modal__create-btn-left">
                  <GroupAddIcon fontSize="large" />
                  <span className="btn-title">New Group +</span>
                </div>
                <ChevronRightIcon fontSize="large" />
              </Button>
            </Grid>
          </Grid>
        )}
        <Grid
          container
          component="div"
          className="share-flags-modal__chip-container"
          alignItems="center"
        >
          {activeStep !== 10 &&
            activeStep !== 11 &&
            selectedItems.map((item) => (
              <Chip
                key={item.itemChipID}
                className="share-chip-item"
                label={chipItemLabelName(item)}
                onDelete={() => onHandleChipItemDelete(item)}
              />
            ))}
          {activeStep === 10 &&
            selectedGroupUsers.map((item) => (
              <Chip
                key={item.itemChipID}
                className="share-chip-item"
                label={chipItemLabelName(item)}
                onDelete={() => onHandleChipCreateGroupItemDelete(item)}
              />
            ))}
        </Grid>
        {activeStep === 11 && renderSelectedGroupUsersHeader()}
        <FormGroup className="share-flags-modal__form-group">
          {activeStep === 0 && renderGroupListItem()}

          {activeStep === 1 && !isSearching && renderUserListItem()}
          {activeStep === 10 && !isSearching && renderCreateGroupUserList()}
          {activeStep === 11 && renderCreateGroupSelectedUserList()}
          {(activeStep === 1 || activeStep === 10) &&
            isSearching &&
            renderListLoader()}
        </FormGroup>
        {specialFlags.length > 0 && <UnsharableFlagsWarning />}
        {activeStep !== 10 && (
          <ShareFlagsModalFooter
            onShareFlags={handleShareFlagAction}
            onCreateAndShare={handleCreateGroupAndShareFlag}
            isSharing={isSharingFlag}
            isCreatingGroup={isCreatingGroup}
            isButtonDisabled={handleShareButtonState}
            activeStep={activeStep}
          />
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (store) => {
  return {
    userGroups: store.app.userGroups,
    isSharingFlag: store.app.isSharingFlag,
    isCreatingGroup: store.app.isCreatingGroup,
    userGroupsSearchUsers: store.app.userGroupsSearchUsers,
    usersAndUserGroups: store.app.usersAndUserGroups
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    shareFlag: async (token, flagId, comment, groupIds, userIds) => {
      await dispatch(
        userGroupShareFlag(token, flagId, comment, groupIds, userIds)
      );
    },
    handleSharing: (isSharing) => {
      dispatch(handleIsSharingFlag(isSharing));
    },
    searchUsers: async (token, feedUrl, searchQuery) => {
      await dispatch(userGroupSearchUsers(token, feedUrl, searchQuery));
    },
    createGroup: async (token, groupName, feedUrl, groupUsers) => {
      const res = await dispatch(
        createUserGroup(token, groupName, feedUrl, groupUsers)
      );
      return res;
    },
    handleCreatingAndSharing: (inAction) => {
      dispatch(handleInCreatingAndSharingFlagAction(inAction));
    },
    handleCreatingGroup: (inAction) => {
      dispatch(handleCreatingGroupAction(inAction));
    },
    fetchGroups: (token, feedUrl) => {
      dispatch(fetchUserGroups(token, feedUrl));
    },
    searchUsersAndUserGroups: (feedUrl, searchQuery, token) => {
      dispatch(fetchUsersAndUserGroups(feedUrl, searchQuery, token));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareFlags);
